import { db } from '../db/index';

const LS_KEY = 'authToken';
const META_ACCESS = 'auth_token';
const META_REFRESH = 'refresh_token';

const hasLocalStorage = () => typeof localStorage !== 'undefined';

/**
 * Persist access + refresh tokens.
 * localStorage write is best-effort (no-op in SW context).
 * IDB writes are awaited so SW callers can rely on durability.
 * @param {{ access?: string, refresh?: string }} tokens
 */
export async function setTokens({ access, refresh }) {
  if (hasLocalStorage() && access) {
    localStorage.setItem(LS_KEY, access);
  }
  const writes = [];
  if (access) {
    writes.push(db.table('meta').put({ key: META_ACCESS, value: access }));
  }
  if (refresh) {
    writes.push(db.table('meta').put({ key: META_REFRESH, value: refresh }));
  }
  await Promise.all(writes);
}

/**
 * Clear all token storage. Idempotent.
 */
export async function clearTokens() {
  if (hasLocalStorage()) {
    localStorage.removeItem(LS_KEY);
  }
  await Promise.all([
    db.table('meta').delete(META_ACCESS),
    db.table('meta').delete(META_REFRESH),
  ]);
}

/**
 * Read access token from IDB (SW-context safe).
 * @returns {Promise<string|null>}
 */
export async function getAccessTokenFromDb() {
  const row = await db.table('meta').get(META_ACCESS);
  return row?.value ?? null;
}

/**
 * Read refresh token from IDB (SW-context safe).
 * @returns {Promise<string|null>}
 */
export async function getRefreshTokenFromDb() {
  const row = await db.table('meta').get(META_REFRESH);
  return row?.value ?? null;
}
